import { __assign } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "inner-btn-content" };
import SvgIcon from "./svg-icon.vue";
var DEFAULT_CLASS = "h-[36px] text-icon";
export default /*@__PURE__*/ _defineComponent(__assign({
    name: "ButtonIcon",
    inheritAttrs: false,
}, { __name: 'button-icon', props: {
        class: { default: "" },
        icon: { default: "" },
        tooltipContent: { default: "" },
        tooltipPlacement: { default: "bottom" },
        zIndex: { default: 98 }
    }, setup: function (__props) {
        var props = __props;
        return function (_ctx, _cache) {
            var _component_NButton = _resolveComponent("NButton");
            var _component_NTooltip = _resolveComponent("NTooltip");
            return (_openBlock(), _createBlock(_component_NTooltip, {
                placement: _ctx.tooltipPlacement,
                "z-index": _ctx.zIndex,
                disabled: !_ctx.tooltipContent
            }, {
                trigger: _withCtx(function () { return [
                    _createVNode(_component_NButton, _mergeProps({
                        quaternary: "",
                        class: 'custom-button-btn-class' + props.class
                    }, _ctx.$attrs), {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_1, [
                                _renderSlot(_ctx.$slots, "default", {}, function () { return [
                                    _createVNode(SvgIcon, { icon: _ctx.icon }, null, 8, ["icon"])
                                ]; })
                            ])
                        ]; }),
                        _: 3
                    }, 16, ["class"])
                ]; }),
                default: _withCtx(function () { return [
                    _createTextVNode(" " + _toDisplayString(_ctx.tooltipContent), 1)
                ]; }),
                _: 3
            }, 8, ["placement", "z-index", "disabled"]));
        };
    } }));
